<template>
    <form @submit.prevent="handleSubmit" autocomplete="off">
        <slot
            :isReadonly="isReadonly"
            :errors="errors"
            :values="data._values"
            :setTouched="setTouched"
            :setValue="setValue"
            :getValue="getValue"
            :getValues="getValues"
            :getError="getError"
            :getErrors="getErrors"
            :getTouched="getTouched"
            :isValid="isValid"
            :isInvalid="isInvalid"
        ></slot>
    <!-- <pre>{{JSON.stringify(data._values, undefined, 2)}}</pre> -->
    </form>
</template>
<script>
export default {
    name: 'form',
    props: {
        autocomplete: String,
        readonly: Boolean,
        errors: {
            type: Object,
            default() {
                return {};
            }
        },
        validate: {
            type: Function,
            default: () => null,
        },
        values: Object,
        defaultValues: {
            type: Object,
            default() {
                return {};
            }
        },
    },
    data() {
        return {
            data: {
                _touched: {},
                _externalErrors: this.errors,
                _errors: {},
                _values: this.values || this.defaultValues,
            }
        }
    },
    created() {
        this.validateForm();
    },
    watch: {
        errors(newErrors = {}) {
            this.data._externalErrors = { ...newErrors };
        },
        values(newValues = {}) {
            this.data._values = {
                ...this.data._values,
                ...newValues,
            };
            this.validateForm();
        }
    },
    methods: {
        validateForm() {
            const errors = this.validate({ ...this.data._values });
            this.data._errors = errors || {};
        },
        handleSubmit() {
            if (this.isValid) {
                this.$emit('submit', { ...this.data._values });
            }
        },
        setValue(field, newValue) {
            this.data._values = {
                ...this.data._values,
                [field]: newValue,
            };

            this.validateForm();
        },
        getError(field) {
            return this.data._errors[field] || this.data._externalErrors[field];
        },
        getErrors() {
            return { ...this.data._errors };
        },
        getValue(field) {
            return this.data._values[field];
        },
        getValues() {
            return { ...this.data._values };
        },
        getTouched(field) {
            return this.data._touched[field];
        },
        setTouched(field, touched) {
            // if (touched && this.data._externalErrors[field]) {
            //     this.data._externalErrors[field] = undefined;
            // }

            this.data._touched = {
                ...this.data._touched,
                [field]: touched,
            };
        },
        isReadonly() {
            return this.readonly;
        }
    },
    computed: {
        isValid() {
            return !this.data._errors || !Object.keys(this.data._errors).length;
        },
        isInvalid() {
            return !this.isValid;
        },
    }
}
</script>


// WEBPACK FOOTER //
// Form.vue?74a154a8